import { defineComponent as d, toRef as n, cloneVNode as l, h as i, resolveComponent as b } from "vue";
import { useTypedButton as c } from "../../composables/button.mjs";
const h = {
  white: {
    defaultClasses: "text-zinc-400 hover:text-zinc-500 border-zinc-300 hover:border-zinc-400 focus:ring-primary-500",
    shadedClasses: "hover:bg-zinc-100 dark:hover:bg-zinc-700 dark:hover:text-zinc-300"
  },
  primary: {
    defaultClasses: "text-primary-400 hover:text-primary-500 border-primary-400 hover:border-primary-500 focus:ring-primary-500",
    shadedClasses: "hover:bg-primary-100 dark:hover:bg-primary-500/25"
  },
  accent: {
    defaultClasses: "text-accent-400 hover:text-accent-500 border-accent-400 hover:border-accent-500 focus:ring-accent-500",
    shadedClasses: "hover:bg-accent-100 dark:hover:bg-accent-500/25"
  },
  indigo: {
    defaultClasses: "text-indigo-400 hover:text-indigo-500 border-indigo-400 hover:border-indigo-500  focus:ring-indigo-500",
    shadedClasses: "hover:bg-indigo-100 dark:hover:bg-indigo-500/25"
  },
  blue: {
    defaultClasses: "text-blue-400 hover:text-blue-500 border-blue-400 hover:border-blue-500",
    shadedClasses: "hover:bg-blue-100 dark:hover:bg-blue-500/25"
  },
  red: {
    defaultClasses: "text-red-400 hover:text-red-500 border-red-400 hover:border-red-500 focus:ring-red-500",
    shadedClasses: "hover:bg-red-100 dark:hover:bg-red-500/25"
  },
  orange: {
    defaultClasses: "text-orange-400 hover:text-orange-500 border-orange-400 focus:ring-orange-500",
    shadedClasses: "hover:bg-orange-100 dark:hover:bg-orange-500/25"
  },
  teal: {
    defaultClasses: "text-teal-400 hover:text-teal-500 border-teal-400 focus:ring-teal-500",
    shadedClasses: "hover:bg-teal-100 dark:hover:bg-teal-500/25"
  },
  purple: {
    defaultClasses: "text-purple-400 hover:text-purple-500 border-purple-400 focus:ring-purple-500",
    shadedClasses: "hover:bg-purple-100 dark:hover:bg-purple-500/25"
  },
  pink: {
    defaultClasses: "text-pink-400 hover:text-pink-500 border-pink-400 focus:ring-pink-500",
    shadedClasses: "hover:bg-pink-100 dark:hover:bg-pink-500/25"
  },
  yellow: {
    defaultClasses: "text-yellow-400 hover:text-yellow-500 border-yellow-400 focus:ring-yellow-500",
    shadedClasses: "hover:bg-yellow-100 dark:hover:bg-yellow-500/25"
  },
  green: {
    defaultClasses: "text-green-400 hover:text-green-500 border-green-400 focus:ring-green-500",
    shadedClasses: "hover:bg-green-100 dark:hover:bg-green-500/25"
  },
  rose: {
    defaultClasses: "text-rose-400 hover:text-rose-500 border-rose-400 focus:ring-rose-500",
    shadedClasses: "hover:bg-rose-100 dark:hover:bg-rose-500/25"
  },
  emerald: {
    defaultClasses: "text-emerald-400 hover:text-emerald-500 border-emerald-400 focus:ring-emerald-500",
    shadedClasses: "hover:bg-emerald-100 dark:hover:bg-emerald-500/25"
  }
}, u = {
  xs: {
    buttonClasses: "size-5 focus:ring-1 border-2",
    iconClasses: "size-3.5"
  },
  sm: {
    buttonClasses: "size-6 focus:ring-1 border-2",
    iconClasses: "size-4"
  },
  base: {
    buttonClasses: "size-8 focus:ring-2 border-2",
    iconClasses: "size-6"
  },
  lg: {
    buttonClasses: "size-10 focus:ring-2 border-2",
    iconClasses: "size-8"
  }
}, g = {
  none: "border-none",
  dashed: "box-content border-dashed",
  dotted: "box-content border-dotted",
  solid: "box-content border-solid"
}, v = d({
  name: "TuiIconButton",
  props: {
    color: {
      type: String,
      default: "white"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    shaded: {
      type: Boolean,
      default: !1
    },
    border: {
      type: String,
      default: "none"
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "base"
    }
  },
  setup(e) {
    return c(n(() => e.type));
  },
  render() {
    if (!this.$slots.default)
      return console.warn("No children passed to TuiIconButton!"), null;
    const e = u[this.size], s = h[this.color], r = g[this.border], o = [
      "rounded-full inline-flex items-center justify-center focus:outline-none disabled:opacity-70 disabled:pointer-events-none",
      s.defaultClasses,
      e.buttonClasses,
      r,
      this.shaded ? s.shadedClasses : ""
    ], t = this.$slots.default()[0], a = l(t, {
      class: e.iconClasses
    });
    return i(
      // prevent warning if component tag is a button
      // TODO: find a better way to check for native components
      this.componentTag === "button" ? "button" : b(this.componentTag),
      {
        class: o,
        type: this.componentType,
        disabled: this.disabled
      },
      a
    );
  }
});
export {
  v as default
};
//# sourceMappingURL=IconButton.vue.mjs.map
